module.exports = __webpack_public_path__ + "assets/calendar_black.fbc65ec9.svg";